import { render, staticRenderFns } from "./LoginPagePhone.vue?vue&type=template&id=251e7c08&"
import script from "./LoginPagePhone.vue?vue&type=script&lang=js&"
export * from "./LoginPagePhone.vue?vue&type=script&lang=js&"
import style0 from "./LoginPagePhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports